import Cache from 'utils/Cache';
import NoticeCache from 'utils/NoticeCache';

const PREFIX = import.meta.env.VITE_NAME || '';

export const localStorageCache = new Cache(localStorage);
export const sessionStorageCache = new Cache(sessionStorage);

export const noticeCache = new NoticeCache(localStorage, `${PREFIX}/notice`);

export const tempPermissionSessionCache = new Cache(sessionStorage, `${PREFIX}/temp-permission`);

export const sploginStorageCache = new Cache(sessionStorage, `${PREFIX}/splogin`);

export const refundTipsCache = new Cache(sessionStorage, `${PREFIX}/refundTips`);

export const preferenceCache = new Cache(localStorage, `${PREFIX}/preference`);

export const newBadgeCache = new Cache(localStorage, `${PREFIX}/new_badge`);

export const inputDraftCache = new Cache(sessionStorage, `${PREFIX}/inputDraft`);
export const inputDraftCache2 = new Cache(sessionStorage, `${PREFIX}/inputDraft2`);

export const shopeeDomainScoreCache = new Cache(localStorage, `${PREFIX}/shopeeDomainScore`);

// 网络延迟节点列表
export const networkNodesCache = new Cache(localStorage, `${PREFIX}/networkNodesCache`);
// 网络延迟节点选择项
export const networkNodeValueCache = new Cache(localStorage, `${PREFIX}/networkNodeValueCache`);
export const flagrNetworkNodeValueCache = new Cache(
  localStorage,
  `${PREFIX}/flagrNetworkNodeValueCache`,
);

export const netScanResultCache = new Cache(localStorage, `${PREFIX}/netScanResult`);

// 授权打开方式
export const authOpenModeCache = new Cache(localStorage, `${PREFIX}/authOpenMode`);
// 会话排序方式
export const conversationSortCache = new Cache(localStorage, `${PREFIX}/conversationSort`);
// todo筛选方式
export const conversationTodoFilterCache = new Cache(localStorage, `${PREFIX}/todoFilter`);
// 快捷短语缓存
export const queryPhrasesV2ETagCache = new Cache(localStorage, `${PREFIX}/queryPhrasesV2/eTag`);
export const queryPhrasesV2DataCache = new Cache(localStorage, `${PREFIX}/queryPhrasesV2/data`);
// 表情包
export const queryStickerEtagV2Cache = new Cache(localStorage, `@${PREFIX}/querySticker/etagV2`);
export const queryStickerDataV2Cache = new Cache(localStorage, `@${PREFIX}/querySticker/dataV2`);

export const reportRecordCache = new Cache(localStorage, `${PREFIX}/reportRecord`);

export const goPlatformServiceNoRemindCache = new Cache(
  localStorage,
  `${PREFIX}/goPlatformServiceNoRemind`,
);
export const goPlatformServiceNoRemind2Cache = new Cache(
  localStorage,
  `${PREFIX}/goPlatformServiceNoRemind2`,
);
export const searchWordsCache = new Cache(localStorage, `${PREFIX}/searchWords`);
export const loginTypeCache = new Cache(localStorage, `${PREFIX}/loginType`);
export const loginCountryCodeCache = new Cache(localStorage, `${PREFIX}/loginCountryCode`);
export const ignoreNotificationCache = new Cache(localStorage, `${PREFIX}/ignoreNotification`);
export const dashboardNewCache = new Cache(localStorage, `${PREFIX}/dashboardNew`);
export const groupGuideCache = new Cache(localStorage, `${PREFIX}/groupGuide`);
export const conversationFilterAdvanceCache = new Cache(
  localStorage,
  `${PREFIX}/conversationFilterAdvance`,
);
export const conversationFilterAdvanceModeCache = new Cache(
  localStorage,
  `${PREFIX}/conversationFilterAdvanceMode`,
);
export const tradeDetailFirstTipCache = new Cache(localStorage, `${PREFIX}/tradeDetailFirstTip`);

export const loggedUserCache = new Cache(sessionStorage, `${PREFIX}/loggedUser`);

export const hostListCache = new Cache(localStorage, `${PREFIX}/hostList`);

export const todoSortCache = new Cache(localStorage, `${PREFIX}/todoSort`);

export const appShortcutDialogCache = new Cache(localStorage, `${PREFIX}/appShortcutDialog`);
export const appShortcutDialogDisableCache = new Cache(
  localStorage,
  `${PREFIX}/appShortcutDialogDisable`,
);

export const requestDownloadPathCache = new Cache(localStorage, `${PREFIX}/requestDownloadPath`);

export const tiktokReviewNotificationCloseTimeCache = new Cache(
  localStorage,
  `${PREFIX}/tiktokReviewNCT`,
);

export const tradeReturnListFilterFoldCache = new Cache(localStorage, `${PREFIX}/trlff`);

export const paneHeightCache = new Cache(localStorage, `${PREFIX}/paneHeight`);

export const todoSearchFilterCache = new Cache(localStorage, `${PREFIX}/todoSearchFilter`);

export const focusModeGuideToastCache = new Cache(localStorage, `${PREFIX}/focusModeGuideToast`);

export const updateUserScope = (userId: string) => {
  conversationSortCache.setScope(userId);
  queryPhrasesV2ETagCache.setScope(userId);
  queryPhrasesV2DataCache.setScope(userId);
  searchWordsCache.setScope(userId);
  goPlatformServiceNoRemindCache.setScope(userId);
  goPlatformServiceNoRemind2Cache.setScope(userId);
  ignoreNotificationCache.setScope(userId);
  dashboardNewCache.setScope(userId);
  groupGuideCache.setScope(userId);
  conversationFilterAdvanceCache.setScope(userId);
  conversationFilterAdvanceModeCache.setScope(userId);
  tradeDetailFirstTipCache.setScope(userId);
  todoSortCache.setScope(userId);
  tiktokReviewNotificationCloseTimeCache.setScope(userId);
  tradeReturnListFilterFoldCache.setScope(userId);
  todoSearchFilterCache.setScope(userId);
  focusModeGuideToastCache.setScope(userId);

  queryPhrasesV2ETagCache.remove();
  queryPhrasesV2DataCache.remove();
};
